import { render, staticRenderFns } from "./AuthForms.vue?vue&type=template&id=5cbb82d5&scoped=true&"
import script from "./AuthForms.vue?vue&type=script&lang=ts&"
export * from "./AuthForms.vue?vue&type=script&lang=ts&"
import style0 from "./AuthForms.vue?vue&type=style&index=0&id=5cbb82d5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cbb82d5",
  null
  
)

export default component.exports